import { isValidQuotation } from "@/features/orders/quotation/utils";
import { useQuotationSearch } from "@repo/api";
import { t } from "@repo/translation";
import { DebouncedSearchField, SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import { useEffect } from "react";

import { SearchResultHandler } from "../../components/SearchResultHandler";
import {
  type AddQuotationState,
  type AddQuotationStateActions,
} from "./AddQuotationReducer";

interface SearchStepProps {
  actions: AddQuotationStateActions;
  state: AddQuotationState;
}

export const SearchCustomerQuotations = ({
  actions,
  state,
}: SearchStepProps) => {
  const { searchValue } = state;

  const searchQuotation = isValidQuotation(searchValue)
    ? searchValue
    : undefined;

  const { data: quotationData, isValidating: isQuotationLoading } =
    useQuotationSearch(searchQuotation);

  const isValidating = isQuotationLoading;

  useEffect(() => {
    const quotationsData = quotationData;
    if (quotationsData) {
      actions.setQuotations(
        Array.isArray(quotationsData) ? quotationsData : [quotationsData]
      );
    }
  }, [actions, quotationData]);

  return (
    <SectionContainer>
      <DebouncedSearchField
        id="seach-quotations-input"
        placeholder={t("prompt.placeholder_search_quotations")}
        debounceTime={700}
        onChange={(term) => {
          actions.setSearchValue(term === "" ? undefined : term);
          trackAnalytics("search_with_email_or_quotation_number");
        }}
      />
      <SearchResultHandler
        isValidating={isValidating}
        isNoData={!quotationData}
        searchValue={searchValue}
      />
    </SectionContainer>
  );
};
